import { Modal, Alert, Button, Form } from '@deere/ux.uxframe-react'
import React from 'react'
import { useTranslation } from "react-i18next";

export default function CmAgreementPopUp({handleClose,showAgreement, submitResponse, survey}) {
    const { t } = useTranslation();
    
    const handleSubmit = event => {
        event.preventDefault();
        event.stopPropagation();
        
        submitResponse();
        handleClose();        
    }

    return (<Modal show={showAgreement} onHide={handleClose} size="lg">
                <Form validated={true} onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('cm_lbl_agreemet_modal')}</Modal.Title>
                </Modal.Header>
                <Modal.Body scrollable={false} style={{maxHeight: '325px',overflowY: "auto"}}>
                    <Alert variant="warning">
                        <h5 className="uxf-alert-title" align="justify">
                            {t('cm_lbl_agreemet_warning')} 
                        </h5>
                    </Alert>
                    <br/>                    
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>{t('btn_cancel')}</Button>
                    <Button variant="primary" onClick={handleSubmit} type='submit'>{t('btn_review_submit')}</Button>
                </Modal.Footer>
                </Form>
            </Modal>)
}